import Language from "./language";
import Framework from "./framework";
import Database from "./database";
import CodeLoginType from "./code_login_type";
import ProjectLogin from "./project_login";
import OcomClient from "./ocom_client";
import OcomProject from "./ocom_project";
import OcomQuoteOld from "./ocom_quote_old";
import QuoteLine from "./quote_line";
import CodeFrontEnd from "./code_front_end";
import CodeQuoteType from "./code_quote_type";
import DocumentTemplate from "./document_template";
import DocumentTemplateVersion from "./document_template_version";
import DocumentTemplateSection from "./document_template_section";
import OcomQuoteVersion from "./ocom_quote_version";
import OcomQuote from "./ocom_quote";
import CodeTaskType from "./code_task_type";
import CodeQuoteStatus from "./code_quote_status";
import UserRole from "./user_role";
import UserStory from "./user_story";
import TimesheetEntry from "./timesheet_entry";
import CodeUserStoryStatus from "./code_user_story_status";

import { default as PermissionSchema } from "../../vue-ocom/grouppermissions/schema/index.js";

export default {
  Language,
  Framework,
  Database,
  CodeLoginType,
  ProjectLogin,
  OcomClient,
  OcomProject,
  OcomQuoteOld,
  QuoteLine,
  CodeFrontEnd,
  CodeQuoteType,
  DocumentTemplate,
  DocumentTemplateVersion,
  DocumentTemplateSection,
  OcomQuoteVersion,
  OcomQuote,
  CodeTaskType,
  CodeQuoteStatus,
  UserRole,
  UserStory,
  TimesheetEntry,
  CodeUserStoryStatus,

  ...PermissionSchema /* For Schema */,
};
